import { render, staticRenderFns } from "./AmostrasProgressBarPrazo.vue?vue&type=template&id=14153d36&"
import script from "./AmostrasProgressBarPrazo.vue?vue&type=script&lang=ts&"
export * from "./AmostrasProgressBarPrazo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VProgressLinear,VTooltip})
